// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"aab21f13","513":"d9066a81","703":"a9c3757b","787":"cd2fefe5"}[chunkId] + ".chunk.js";
};